import React from 'react'
import type { InterviewQuestionOptionsResource } from '@entities/api/Interview'
import { useFormContext } from 'react-hook-form'

interface Props {
  prefix: string
  itemName: string | null
  required: boolean
  options: InterviewQuestionOptionsResource
}

const Agreement: React.FC<Props> = ({ prefix, itemName, required, options }) => {
  const { register } = useFormContext()
  const errorPrefix = `${itemName ? `${itemName}について、` : ''}`

  const { text, label } = options

  const inputName = `${prefix}.value`

  return (
    <>
      <div className="row pb-3">
        <div className="col">
          <div className="zm-pre bg-light p-2">{text}</div>
        </div>
      </div>
      <div className="row pb-4">
        <div className="col">
          <label className="border-0 zm-checkbox m-0 mb-2 w-100">
            <input
              ref={register({ required: required && `${errorPrefix}チェックが必要です` })}
              type="checkbox"
              className="d-none"
              name={inputName}
              value="agree"
            />
            <div className="zm-checkmark zm-checkmark-t2" />
            {label}
          </label>
        </div>
      </div>
    </>
  )
}

export default Agreement
